// extracted by mini-css-extract-plugin
export default {"external":"aqATTk","plateSubAddons":"bqATTk"};